import defaultClient from '@src/api/clients/default';

export function fetchZipSubmissions(params = {}) {
  const query = new URLSearchParams(params).toString();
  return defaultClient.request({
    url: `dashboard/zip-submissions/?${query}`,
    method: 'GET',
  });
}

export function fetchLatestByTerritory(params) {
  const query = new URLSearchParams(
    typeof params === 'object' && params !== null ? params : { client_id: params }
  ).toString();
  return defaultClient.request({
    url: `dashboard/zip-submissions/latest-by-territory/?${query}`,
    method: 'GET',
  });
}

export function fetchZipSubmission(id) {
  return defaultClient.request({
    url: `dashboard/zip-submissions/${id}/`,
    method: 'GET',
  });
}

export function fetchZipSubmissionGeometry(ids) {
  const list = (Array.isArray(ids) ? ids : [ids]).filter(Boolean);
  return defaultClient.request({
    url: `dashboard/zip-submissions/geometry/?ids=${list.join(',')}`,
    method: 'GET',
  });
}

export function createZipSubmission(payload) {
  return defaultClient.request({
    url: 'dashboard/zip-submissions/',
    method: 'POST',
    payload,
  });
}

export function approveZipSubmission(id, payload = {}) {
  return defaultClient.request({
    url: `dashboard/zip-submissions/${id}/approve/`,
    method: 'POST',
    payload,
  });
}

export function rejectZipSubmission(id, payload = {}) {
  return defaultClient.request({
    url: `dashboard/zip-submissions/${id}/reject/`,
    method: 'POST',
    payload,
  });
}

export function cancelZipSubmission(id) {
  return defaultClient.request({
    url: `dashboard/zip-submissions/${id}/cancel/`,
    method: 'POST',
  });
}

export function checkZipOverlap(payload) {
  return defaultClient.request({
    url: 'dashboard/zip-submissions/check-overlap/',
    method: 'POST',
    payload,
  });
}

export function pauseTerritory(payload) {
  return defaultClient.request({
    url: 'dashboard/zip-submissions/pause-territory/',
    method: 'POST',
    payload,
  });
}

export function fetchClientPauseEvents(clientId) {
  return defaultClient.request({
    url: `dashboard/client-territories/pause-events/?client_id=${clientId}`,
    method: 'GET',
  });
}

export function fetchTerritoryPauseHistory(territoryId, clientId) {
  // client_id is required for client members — the permission layer resolves
  // access from it (detail routes on this viewset don't carry a client kwarg).
  return defaultClient.request({
    url: `dashboard/client-territories/${territoryId}/pause-history/?client_id=${clientId}`,
    method: 'GET',
  });
}

export function exportZipCoverageCsv(clientId) {
  return defaultClient.request({
    url: `dashboard/client-zips/export-csv/?client_id=${clientId}`,
    method: 'GET',
    responseType: 'blob',
  });
}

export function revertZipSubmission(submissionId, payload = {}) {
  return defaultClient.request({
    url: `dashboard/zip-submissions/${submissionId}/revert/`,
    method: 'POST',
    payload,
  });
}

export function bulkCreateZipSubmissions(payload) {
  return defaultClient.request({
    url: 'dashboard/zip-submissions/bulk-create/',
    method: 'POST',
    payload,
  });
}

export function previewBulkZipUpload(payload) {
  return defaultClient.request({
    url: 'dashboard/zip-submissions/bulk-preview/',
    method: 'POST',
    payload,
  });
}

export function commitBulkZipUpload(payload) {
  return defaultClient.request({
    url: 'dashboard/zip-submissions/bulk-commit/',
    method: 'POST',
    payload,
  });
}

export function assistBulkZipMapping(payload) {
  return defaultClient.request({
    url: 'dashboard/zip-submissions/bulk-map-assist/',
    method: 'POST',
    payload,
  });
}

export function batchApproveZipSubmissions(batchId) {
  return defaultClient.request({
    url: 'dashboard/zip-submissions/batch-approve/',
    method: 'POST',
    payload: { batch_id: batchId },
  });
}

export function downloadZipTemplate(params) {
  const query = new URLSearchParams(
    typeof params === 'object' && params !== null ? params : { client_id: params }
  ).toString();
  return defaultClient.request({
    url: `dashboard/zip-submissions/download-template/?${query}`,
    method: 'GET',
    responseType: 'blob',
  });
}

export function getBatchPushReadiness(clientId, verticalIds = null) {
  const params = new URLSearchParams({ client_id: clientId });
  if (verticalIds?.length) params.set('vertical_ids', verticalIds.join(','));
  return defaultClient.request({
    url: `dashboard/zip-submissions/batch-push-readiness/?${params.toString()}`,
    method: 'GET',
  });
}

export function batchPushZipSubmissionsToFacebook(payload) {
  return defaultClient.request({
    url: 'dashboard/zip-submissions/push-to-facebook-batch/',
    method: 'POST',
    payload,
  });
}

export function pauseVerticalCampaigns(clientId, verticalId) {
  return defaultClient.request({
    url: 'dashboard/zip-submissions/pause-vertical-campaigns/',
    method: 'POST',
    payload: { client_id: clientId, vertical_ids: [verticalId] },
  });
}

export function resumeVerticalCampaigns(clientId, verticalId) {
  return defaultClient.request({
    url: 'dashboard/zip-submissions/resume-vertical-campaigns/',
    method: 'POST',
    payload: { client_id: clientId, vertical_ids: [verticalId] },
  });
}
